import appGlobalScript from '/home/vsts/work/1/s/packages/apps/global-search/src/global/scripts.ts';
export const globalScripts = appGlobalScript;
